import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import { Tooltip } from "react-tooltip";
import { PayoutCurrency } from "../../redux/features/payment/payment.types";
import {
  currencyShorts,
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { formatToCurrency } from "../../utils/helpers";
import { Icon } from "../icon/icon";
import { RenderMarkdown } from "../typography/renderMarkdown";
import { BgWrapper } from "../wrapper/bgWrapper";

export const NumberCard = ({
  value,
  text,
  isCurrency = true,
  tooltipId,
  tooltipText,
  loading = false,
  titleFirst = false,
  decimalPlaces = 0,
  className = "",
  currency = "NGN",
}: {
  value: number | string;
  text: string;
  isCurrency?: boolean;
  tooltipId?: string;
  tooltipText?: string;
  loading?: boolean;
  titleFirst?: boolean;
  decimalPlaces?: number;
  className?: string;
  currency?: PayoutCurrency;
}) => {
  return (
    <BgWrapper
      className={classNames(
        "flex flex-col gap-1 border border-grey-200",
        className,
      )}
    >
      {loading ? (
        <Skeleton
          width={"30%"}
          height={23}
          baseColor={SKELETON_BASE_COLOR}
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
        />
      ) : (
        <p className="text-[20px] font-extrabold md:text-2xl">
          {isCurrency
            ? formatToCurrency(value, {
                decimalPlaces: decimalPlaces,
                currency: currencyShorts[currency],
              })
            : value.toLocaleString()}
        </p>
      )}

      {loading ? (
        <Skeleton
          width={"100%"}
          height={24}
          baseColor={SKELETON_BASE_COLOR}
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          className={`${titleFirst && "order-first"}`}
        />
      ) : (
        <p
          className={`flex items-center gap-1 text-sm capitalize text-grey-600 md:text-base ${titleFirst && "order-first"}`}
        >
          {text}
          {tooltipId && (
            <span id={`${tooltipId}`}>
              <Icon width={20} height={20} svg="info" />
            </span>
          )}
        </p>
      )}

      <Tooltip anchorSelect={`#${tooltipId}`} className="tooltip">
        <RenderMarkdown>{tooltipText}</RenderMarkdown>
      </Tooltip>
    </BgWrapper>
  );
};
